export const formatTrafficBytes = (bytes) => {
  if (bytes === 0 || bytes === null || bytes === undefined) {
    return "0.00 GB";
  }
  const gb = bytes / (1024 * 1024 * 1024);
  return `${gb.toFixed(2)} GB`;
};

export const formatMostApChannel = (mostApChannel) => {
  if (!mostApChannel) return "-";
  const band = mostApChannel.band === "2.4GHz" ? "2.4G" : mostApChannel.band;
  return `${band} ch${mostApChannel.channel} (${mostApChannel.count} APs)`;
};

export const getScaleFactorAndUnit = (maxVal) => {
  const gbLimit = 1024 * 1024 * 1024;
  return {
    scaleFactor: gbLimit,
    unit: "GB",
  };
};

export const getOverviewRequestConfig = (auth, summaryReportId, standalone) => {
  const apiResource = standalone
    ? "/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview.read"
    : "/ents/:entId/orgs/:orgId/sites/:siteId/summaryReports/:summaryReportId/overview.read";

  const restfulPlaceholders = standalone
    ? {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
      summaryReportId,
    }
    : {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
      summaryReportId,
    };

  return { apiResource, restfulPlaceholders };
};